import { defineStore } from 'pinia'
import { StockService, ResponseError } from '@/services/app/stock.service'
import type { Stock } from '@/types/model'
import type { AxiosResponse } from 'axios'

export const useStockStore = defineStore('stock', {
  state: () => ({
    responseData: '',
    responseErrorCode: 0,
    responseError: '',
  }),

  getters: {
    // Getter untuk responseErrorCode
    getResponseErrorCode: (state) => state.responseErrorCode,

    // Getter untuk responseError
    getResponseError: (state) => state.responseError,
  },

  actions: {
    // Memuat stock
    async loadStock(params: string = ''): Promise<AxiosResponse> {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stock(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Memuat stock create input
    async loadStockCreate(): Promise<AxiosResponse> {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockCreate()
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Memuat stock input
    async loadStockData(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockData(id)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Send stock input
    async addStock(params: Stock) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockAdd(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Send edit stock input
    async editStock(params: Stock) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockEdit(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // validate stock input
    async validateStock(params: Stock) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockValidate(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // delete stock input
    async deleteStock(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockDelete(id)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // restore stock input
    async restoreStock(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const stock: Stock = { id }
        const resp = await StockService.stockRestore(stock)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // delete permanent stock input
    async deletePermanentStock(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const stock: Stock = { id }
        const resp = await StockService.stockDeletePermanent(stock)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },
    // generate paid
    async generatePaidStock(params: Stock) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await StockService.stockGeneratePaid(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },
  },
})
